import React, { useMemo } from 'react';
import './service.css';
import { useDispatch, useSelector } from "react-redux";
import { setScheduleAction } from "../../redux/actions";

const Service = ({ data }) => {
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.schedule);

    const service_inactive = useMemo(() => {
        if (schedule.selected_services.includes(data.id)) return false;
        if (!data.active) return true;

        // Если мастер выбран
        if (schedule.master > 0) {
            const duration = schedule.selected_services.reduce((total, serviceId) => {
                const service = schedule.services.find(s => s.id === serviceId);
                return total + (service ? service.duration_sec : 0);
            }, 0);

            if (
                schedule.max_service_duration_by_master[schedule.master] &&
                schedule.max_service_duration_by_master[schedule.master] <= data.duration_sec + duration
            ) {
                return true;
            }
            return false;
        }

        // Если нет выбранных услуг
        if (schedule.selected_services.length === 0) {
            return false;
        }

        // Все выбранные услуги + текущая
        const allRequiredServices = [...schedule.selected_services, data.id];

        // Расчет общей длительности
        const totalDuration = allRequiredServices.reduce((total, serviceId) => {
            const service = schedule.services.find(s => s.id === serviceId);
            return total + (service ? service.duration_sec : 0);
        }, 0);

        // Определяем мастеров для проверки
        const mastersToCheck = schedule.available_masters?.length > 0
            ? schedule.available_masters
            : Object.keys(schedule.all_master_services || {});

        // Проверяем наличие мастера, который может выполнить все услуги
        const hasAvailableMaster = mastersToCheck.some(masterId => {
            const masterServiceList = schedule.all_master_services?.[masterId];
            if (!masterServiceList) return false;

            // Проверка, может ли мастер выполнить все необходимые услуги
            const canPerformAll = allRequiredServices.every(serviceId =>
                masterServiceList.includes(Number(serviceId))
            );

            if (!canPerformAll) return false;

            // Проверка временных ограничений
            const maxDuration = schedule.max_service_duration_by_master?.[masterId];
            return !maxDuration || totalDuration <= maxDuration;
        });

        return !hasAvailableMaster;

    }, [schedule]);

    return (
        <div className={ `service schedule__item ${ schedule.selected_services.includes(data.id) && 'schedule__item--active' } ${ service_inactive ? 'schedule__item--inactive' : '' }` }
             onClick={ () => {
                 let selected_services_copy = [...schedule.selected_services];

                 if (selected_services_copy.includes(data.id)) {
                     selected_services_copy = selected_services_copy.filter(el => el !== data.id);
                 }
                 else {
                     selected_services_copy.push(data.id);
                 }

                 dispatch(setScheduleAction({
                     ...schedule,
                     selected_services: selected_services_copy
                 }));
             } }
        >
            <div className="service__name">{ data.name }</div>
            <div className="service__duration">{ data.duration }</div>
        </div>
    );
};

export default Service;